/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityDataleaks } from './ControlEntityDataleaks';
import {
    ControlEntityDataleaksFromJSON,
    ControlEntityDataleaksFromJSONTyped,
    ControlEntityDataleaksToJSON,
} from './ControlEntityDataleaks';

/**
 * 
 * @export
 * @interface Dataleaks
 */
export interface Dataleaks {
    /**
     * 
     * @type {number}
     * @memberof Dataleaks
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof Dataleaks
     */
    password?: number;
    /**
     * 
     * @type {number}
     * @memberof Dataleaks
     */
    pii?: number;
}

/**
 * Check if a given object implements the Dataleaks interface.
 */
export function instanceOfDataleaks(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DataleaksFromJSON(json: any): Dataleaks {
    return DataleaksFromJSONTyped(json, false);
}

export function DataleaksFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dataleaks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'pii': !exists(json, 'pii') ? undefined : json['pii'],
    };
}

export function DataleaksToJSON(value?: Dataleaks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'password': value.password,
        'pii': value.pii,
    };
}

